<div class="dup-header">
	<span style="display: inline-block;">
		Member:<label class="member-name" style="width: 400px;">{{ getFormattedMemberName(primaryRecord) }}</label>
		DOB:<label class="member-name">{{primaryRecord?.dateOfBirth | date:'mediumDate':'EST'}}</label>
		<span style="float: right;margin-right: 10px;">Date Added:<label class="member-name">{{primaryRecord?.dateAdded | date:'mediumDate':'EST'}}</label></span>
	</span>
</div>

	<div class="duplicate-members-grid-container">
	   <table mat-table [dataSource]="dataSource" style="width: 100%">

									<ng-container matColumnDef="select">
									    <th mat-header-cell *matHeaderCellDef class="table-header-style-override" style="width: 50px;background-color: #e1e1e1;">
									    </th>
									    <td mat-cell *matCellDef="let element;let tableRowIdx = index;" style="width: 50px !important;">
									        <mat-checkbox (click)="$event.stopPropagation();" [disabled]="false" [value]="element.isSelected" [(ngModel)]="element.isSelected">
									        </mat-checkbox>
									    </td>
									</ng-container>
				                   <ng-container matColumnDef="firstName">
								    <th mat-header-cell class="mat-table-header-style mat-table-header-override"
										*matHeaderCellDef> First
									</th>
								    <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
										class="table-row-class">
								    <span>{{element.firstName}}</span>
								    </td>
								  </ng-container>
                                    <ng-container matColumnDef="middleName">
                                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                            *matHeaderCellDef> Middle
                                        </th>
                                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                            class="table-row-class">
                                            <span>{{element.middleName}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="lastName">
									  <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style mat-table-header-override"> Last</th>
									  <td mat-cell *matCellDef="let element"  style="padding-left: 1px" class="table-row-class">
									    <span>{{element.lastName}}</span>
									  </td>
									</ng-container>
									
								<ng-container matColumnDef="dateOfBirth">
								  <th mat-header-cell *matHeaderCellDef
									  class="mat-table-header-style mat-table-header-override"> DOB </th>
								  <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
								    <span>{{element.dateOfBirth | date:'mediumDate':'EST'}}</span>
								  </td>
								</ng-container>

                                <ng-container matColumnDef="gender">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="mat-table-header-style mat-table-header-override"> Gender </th>
                                    <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                                        <span>{{element.gender}}</span>
                                    </td>
                                </ng-container>
                                 <ng-container matColumnDef="dateAdded">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="mat-table-header-style mat-table-header-override"> Date Added </th>
                                    <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                                        <span>{{element.dateAdded | date:'mediumDate':'EST'}}</span>
                                    </td>
                                </ng-container>

							  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			                  <tr mat-row
			                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
			                        [ngClass]="{'row-selected': tableRowIdx == Idx}">
				                  </tr>
				                </table>
							<app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
</div>

<div>
    <!-- Three radio buttons -->
    <mat-radio-group [(ngModel)]="selectedOption">
        <mat-radio-button class="radio-btn" value="option1">Choose / Use the record in the table (select only one)</mat-radio-button><br>
        <mat-radio-button class="radio-btn" value="option2">Suppress the record(s) in the table</mat-radio-button><br>
        <mat-radio-button class="radio-btn" value="option3">Accept that records are different people</mat-radio-button>
    </mat-radio-group>
</div>

 <!----------------------->
  <!-- ERROR LINE --------->
  <!----------------------->
  <div class="error-line" [hidden]='!strErr.length'
       style="text-align:left; bottom: 45px;">{{strErr}}</div>
  <!----------------------->
  <!-- SAVE STRIP        -->
  <!----------------------->
  <div class="save-close-strip" style="bottom: 10px;">

      <button mat-button class="command-button"
              (click)="submitRecord()" matTooltip="Apply changes" [disabled]="!this.selectedOption"
              mat-button>
          <mat-icon>check_circle_outline</mat-icon>
          Apply
      </button>
      <button mat-button class="command-button" 
              (click)="cancelSubmitRecord()" matTooltip="Close window" mat-button>
          <mat-icon>highlight_off</mat-icon>
          Cancel
      </button>
  </div>
